import { SettingsMenu } from "web/components"

import {
  CurrencyDollarIcon,
  PencilIcon,
  TrashIcon,
  UserGroupIcon,
  ArrowDownTrayIcon,
} from "@heroicons/react/24/outline"

export default function ViewSettingsMenu({
  view,
  onShare,
  onRename,
  onDelete,
  onUpdateUnits,
  onPipelineStatistics,
}) {
  const menuItems = [
    {
      icon: CurrencyDollarIcon,
      label: "Currency and Units",
      onClick: onUpdateUnits,
    },
  ]

  if (view.subject_type === "Deal" && !view.parentSubjectType) {
    menuItems.push({
      icon: ArrowDownTrayIcon,
      label: "Pipeline Statistics",
      onClick: onPipelineStatistics,
    })
  }

  if (view.userCan("destroy")) {
    menuItems.unshift({
      icon: TrashIcon,
      label: "Delete",
      onClick: onDelete,
    })
  }

  if (view.userCan("rename")) {
    menuItems.unshift({
      icon: PencilIcon,
      label: "Rename",
      onClick: onRename,
    })
  }

  if (
    view.userCan("share") ||
    (view.parentSubjectType === "Market" && view.type === "view")
  ) {
    menuItems.unshift({
      icon: UserGroupIcon,
      label: "Sharing",
      onClick: onShare,
    })
  }

  return <SettingsMenu menuItems={menuItems} />
}
